// // src/utils/appsflyer.js

// src/utils/appsflyer.js

export const AF_EVENTS = {
  //Login & SignUp
  AF_LOGIN: "MP_LOGIN",
  AF_ERROR_LOGIN: "MP_ERROR_LOGIN",
  MP_SIGNUP: "MP_SIGNUP",
  MP_ERROR_SIGNUP: "MP_ERROR_SIGNUP",
  //Home page 
  MP_HOME: "MP_HOME",
  //Sidebar
  MP_BOTTOM_FANTASY: "MP_BOTTOM_FANTASY",
  MP_BOTTOM_CONTEST: "MP_BOTTOM_GAME",
  MP_BOTTOM_HOME: "MP_BOTTOM_HOME",
  MP_BOTTOM_TRADING: "MP_BOTTOM_TRADING",
  MP_BOTTOM_LMS: "MP_BOTTOM_LMS",
  //ProfileSidebar
  MP_QUIZ: "MP_QUIZ",
  MP_SHOP_CLICK: "MP_SHOP_CLICK",
  MP_SHOP_PRODUCT_CLICK: "MP_SHOP_PRODUCT_CLICK",
  MP_EARNCOIN_CLICK: "MP_EARNCOIN_CLICK",
  MP_SPINWHEEL_CLICK: "MP_SPINWHEEL_CLICK",
  MP_SPINWHEEL_PLAY: "MP_SPINWHEEL_PLAY",
  //Fantasy Events
  MP_PUBLIC_FANTASY: "MP_PUBLIC_FANTASY",
  MP_PRIVATE_FANTASY: "MP_PRIVATE_FANTASY",
  MP_JOIN_FANTASY: "MP_JOIN_FANTASY",
  MP_CREATE_FANTASY: "MP_CREATE_FANTASY",
  //Contest Events
  MP_PUBLIC_CONTEST: "MP_PUBLIC_GAME",
  MP_PRIVATE_CONTEST: "MP_PRIVATE_GAME",
  MP_JOIN_CONTEST: "MP_JOIN_GAME",
  MP_CREATE_CONTEST: "MP_CREATE_GAME",
  MP_LEAVE_CONTEST: "MP_LEAVE_GAME",
  MP_DELETE_CONTEST: "MP_DELETE_GAME",
  //Trading Events
  MP_TORO_PORTFOLIO: "MP_TORO_PORTFOLIO",
  MP_PORTFOLIO: "MP_PORTFOLIO",
  MP_DELETE_MP_PORTFOLIO: "MP_DELETE_MP_PORTFOLIO",
  //LMS Events
  MP_LMS_FREE: "MP_LMS_FREE",
  MP_LMS_PAID: "MP_LMS_PAID",
  MP_LMS_COURSE_PURCHASE: "MP_LMS_COURSE_PURCHASE",
};

let isReady = false;

export const initAppsFlyer = (retryInterval = 300) => {
  const check = () => {
    if (typeof window.AF === 'function') {
      isReady = true;
      console.log('AppsFlyer SDK ready.');
    } else {
      setTimeout(check, retryInterval);
    }
  };
  check();
};

export const setAFCustomerUserId = (userId) => {
  if (!isReady) {
    console.warn('AppsFlyer SDK not ready. Call `initAppsFlyer()` first.');
    return;
  }
  window.AF('pba', 'setCustomerUserId', userId);
};

export const trackAFEvent = (eventName, eventProps = {}) => {
  if (!isReady) {
    console.warn('AppsFlyer SDK not ready. Call `initAppsFlyer()` first.');
    return;
  }

  window.AF('event', eventName, eventProps);
  // window.AF('pba', 'event', {
  //   eventType: 'EVENT',
  //   eventName,
  //   eventValue: eventProps
  // });
};




// export const AF_EVENTS = {
//   //Login & SignUp
//   AF_LOGIN: "MP_LOGIN",
//   AF_ERROR_LOGIN: "MP_ERROR_LOGIN",
//   MP_SIGNUP: "MP_SIGNUP",
//   MP_ERROR_SIGNUP: "MP_ERROR_SIGNUP",
//   //Home page 
//   MP_HOME: "MP_HOME",
//   //Sidebar
//   MP_BOTTOM_FANTASY: "MP_BOTTOM_FANTASY",
//   MP_BOTTOM_CONTEST: "MP_BOTTOM_GAME",
//   MP_BOTTOM_HOME: "MP_BOTTOM_HOME",
//   MP_BOTTOM_TRADING: "MP_BOTTOM_TRADING",
//   MP_BOTTOM_LMS: "MP_BOTTOM_LMS",
//   //ProfileSidebar
//   MP_QUIZ: "MP_QUIZ",
//   MP_SHOP_CLICK: "MP_SHOP_CLICK",
//   MP_SHOP_PRODUCT_CLICK: "MP_SHOP_PRODUCT_CLICK",
//   MP_EARNCOIN_CLICK: "MP_EARNCOIN_CLICK",
//   MP_SPINWHEEL_CLICK: "MP_SPINWHEEL_CLICK",
//   MP_SPINWHEEL_PLAY: "MP_SPINWHEEL_PLAY",
//   //Fantasy Events
//   MP_PUBLIC_FANTASY: "MP_PUBLIC_FANTASY",
//   MP_PRIVATE_FANTASY: "MP_PRIVATE_FANTASY",
//   MP_JOIN_FANTASY: "MP_JOIN_FANTASY",
//   MP_CREATE_FANTASY: "MP_CREATE_FANTASY",
//   //Contest Events
//   MP_PUBLIC_CONTEST: "MP_PUBLIC_GAME",
//   MP_PRIVATE_CONTEST: "MP_PRIVATE_GAME",
//   MP_JOIN_CONTEST: "MP_JOIN_GAME",
//   MP_CREATE_CONTEST: "MP_CREATE_GAME",
//   MP_LEAVE_CONTEST: "MP_LEAVE_GAME",
//   MP_DELETE_CONTEST: "MP_DELETE_GAME",
//   //Trading Events
//   MP_TORO_PORTFOLIO: "MP_TORO_PORTFOLIO",
//   MP_PORTFOLIO: "MP_PORTFOLIO",
//   MP_DELETE_MP_PORTFOLIO: "MP_DELETE_MP_PORTFOLIO",
//   //LMS Events
//   MP_LMS_FREE: "MP_LMS_FREE",
//   MP_LMS_PAID: "MP_LMS_PAID",
//   MP_LMS_COURSE_PURCHASE: "MP_LMS_COURSE_PURCHASE",
// };

// let isReady = false;

// export const initAppsFlyer = () => {
//   if (typeof window.AF !== 'function') {
//     console.warn('AppsFlyer SDK not loaded.');
//     return;
//   }
//   isReady = true;
// };

// export const trackAFEvent = (eventName, eventProps = {}) => {
//   if (!isReady || typeof window.AF !== 'function') {
//     console.warn('AppsFlyer SDK not ready. Call `initAppsFlyer()` first.');
//     return;
//   }

//   window.AF('event', eventName, eventProps);
// };
